module.exports = __webpack_public_path__ + "img/img-3.79c7e869.jpg";